import { AxiosResponse } from 'axios';
import { api, IStripeApi } from '../base';
import { Result } from '@/main/models/common/resultResponse';
import { apiIntegration } from '../base/apiIntegration';

const baseRoute: string = 'stripe';

export class StripeApi extends IStripeApi {
  sessionStatus(idSession: string): Promise<AxiosResponse<Result<string>>> {
    return apiIntegration.get(`${baseRoute}/sessionstatus`, {
      params: { idSession }
    });
  }
}

